module.exports = __webpack_public_path__ + "static/media/banner4.62fd6b92.png";